<template>
  <div class="page-shell container">
    <div class="page-header">
      <h1>Recently Viewed</h1>
      <p>Products you've recently checked out.</p>
    </div>

    <div v-if="items && items.length" class="products-grid">
      <ProductCard
        v-for="product in items"
        :key="product.id || product.slug"
        :product="product"
      />
    </div>

    <div v-else class="empty-state">
      No products found.
    </div>
  </div>
</template>

<script setup>
import ProductCard from '../../components/home/ProductCard.vue'

defineProps({
  items: {
    type: Array,
    required: true
  }
})
</script>
